<script setup>
import {ElTooltip, ElMessage, ElLoading} from 'element-plus'
import { onMounted, onUnmounted, ref, h, getCurrentInstance, computed, watch } from 'vue'
import { initAmap, createMarkers,isNeedClearMarkers,clearIsNeedClearMarkers, hoverCurrentItem, cancelHoverCurrentItem,setMapZooms, createProvinceMarker, createCityMarker, currentZoomStr, districtExplorer, removeMarkList, setCurrentAreaCodes, returnChinaMap, getProjectListFn, currentAreaCodes, hiddenMarkerList, reDrawCircle,delCompareDOM,restoreProjectMarkerIcon, drawProvince, map } from './js/map'
import request from '@/service/request';
import {
  getClientHeadData,
  GetDataTotal,
  GetDataList,
  GetProjectList,
  Landtotal,
  GetDataTopNumber,
  GetProjectPageList,
  searchProjectList,
  getCityGroupList
} from '@/service/api'
import {useRouter} from "vue-router";
import {useInsightProject} from "@/router/linkroute";
import {warehouseArea} from "../../tool/number";
const quarter = localStorage.getItem('mapTime') ? localStorage.getItem('mapTime') : '2023 Q3';
const PAGESIZE = 200;
let cityCascaderLoading = null;
let projectName = ref("");
let currentMapDataType = ref(1); // 1是高标仓 2是冷库
let currentPage = ref(1);
let selectType = ref(2);
let cityList = [];
let cityListOptions = ref([]);
let cityCurrentModel = ref([]);
let list = ref([]); //高标仓、冷库的数据列表
let listPageTotal = ref(0);
let listItemFocusIndex = ref(null);
let isListItemShowIndex = ref(0);
let dataType = ref(1);
let isShowDataInfo = ref(false);
let warehouseData = ref({});
let landData = ref({});
let cityName = ref("");
let showTopTen=ref(false)
let isShowFilterOptions = ref(false);
let isSearchModel = ref(false);
let checkAll1 = ref(false);
let checkAll2 = ref(false);
let totalAreaInput1 = ref('');
let totalAreaInput2 = ref('');
let totalAreaInputCache1 = ref('');
let totalAreaInputCache2 = ref('');
let normalRentAreaInput1 = ref('');
let normalRentAreaInput2 = ref('');
let normalRentAreaInputCache1 = ref('');
let normalRentAreaInputCache2 = ref('');
let vacancyRateInput1 = ref('');
let vacancyRateInput2 = ref('');
let vacancyRateInputCache1 = ref('');
let vacancyRateInputCache2 = ref('');
let effectiveRentInput1 = ref('');
let effectiveRentInput2 = ref('');
let effectiveRentInputCache1 = ref('');
let effectiveRentInputCache2 = ref('');
let projectNameSwitch= ref(0);
let projectPointSwitch= ref(1);
let projectPointRemark= ref(1);
let hiddenProjectRemark= 1;
let hiddenProjectName= 1;
let hiddenProjectPoint= 1;
let isShowInfo = ref(true);
let loadingVisible = true;
let loadingPercentage=100;
let cityAuthList=[]
let optionList = ref([
  { id: 1, key: "totalArea", name: "项目总量", value: [], cacheValue: [], hidden: false },
  { id: 2, key: "rptBuildingTypeNames", name: "建筑类型", value: [], cacheValue: [], hidden: false },
  { id: 3, key: "dischargeCargo", name: "卸货类型", value: [], cacheValue: [], hidden: false },
  { id: 4, key: "maxBuiltTime", name: "建成时间", value: [], cacheValue: [], hidden: false },
  { id: 5, key: "normalRentArea", name: "空置面积", value: [], cacheValue: [], hidden: false },
  { id: 6, key: "vacancyRate", name: "空置率", value: [], cacheValue: [], hidden: false },
  { id: 7, key: "effectiveRent", name: "预估有效租金", value: [], cacheValue: [], hidden: false },
])
let selectOptions = ref([
  // { label: "按省份", value: 1 },
  { label: "按城市", value: 2 },
  { label: "按城市群", value: 4 },
  { label: "按区县", value: 3 }
])

watch(()=>cityCurrentModel,(newVal,oldVal)=>{
  let cityCurrentModelVal=newVal.value
  showTopTen.value=false
  for (let i=0;i<cityAuthList.length;i++){
    for (let j = 0; j < cityCurrentModelVal.length; j++) {
      if (cityCurrentModelVal[j]==cityAuthList[i]){
        showTopTen.value = true;
        break;
      }
    }
  }
},{
  deep:true
})

let projectFilterType = ref([1, 2, 3]);
let projectFilterAll = ref(true);
let isShowProjectFilter = ref(false);

let tableData = ref([]);

let isShowCampare = ref(0) // 0 都隐藏 1显示对比栏按钮 隐藏对比栏 2隐藏对比栏按钮 显示对比栏;

let urbanAgglomerationsProvices = ref([]);
let urbanAgglomerationsOptions = [];
let urbanAgglomerationsValue = ref(null);

const urbanLoading = ref(true);
const urbanAgglomerationsLoading = () => {
  urbanLoading.value = false;
}


const triggleShowInfo = () => {
  isShowInfo.value = !isShowInfo.value;
}

const setIsShowProjectFilter = (flag) => {
  isShowProjectFilter = flag;
}

const cityCascaderVisChange=()=>{
    let loadingOptions = {
      target: '.cityLoading',//你自定义的类名
      lock: true,
      text: '拼命加载中...',
      // background: 'rgba(0, 0, 0, 0.7)',
    };

    if (this.options.length === 0) {
      cityCascaderLoading = ElLoading.service(loadingOptions);
      setTimeout(() => {
        cityCascaderLoading.close();
      }, 15000);// 设置遮罩层关闭时间 一般为接口超时时间
    }


    // this.$nextTick(() => {
    //   // 如果完整引入了 Element，那么 Vue.prototype 上会有一个全局方法 $loading。
    //   //this.$loading 是Element的语法 将loading 样式放入指定的元素内
    //   // this.cascaderLoading = this.$loading(option)
    //
    //   if (this.options.length == 0) {
    //     cityCascaderLoading = ElLoading.service(loadingOptions);
    //     setTimeout(() => {
    //       cityCascaderLoading.close();
    //     }, 15000);// 设置遮罩层关闭时间 一般为接口超时时间
    //   }
    // });
}
let loading = null;
const showLoading = (params) => {
    if (loading) {
        loading.close()
    }
    let options = {
        fullscreen: false,
        target: document.querySelector('#mainLoad'),
        lock: true,
        text: '数据加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0,0,0,0.7)'
    }
    Object.assign(
        options,
        params
    )
    loading = Loading.service(options)
}
const changeCurrentPageDataType = async (type) => {
  currentMapDataType.value = type;
  if (type == 1) {
    selectOptions.value = [
      //{ label: "按省份", value: 1 },
      { label: "按城市群", value: 4 },
      { label: "按城市", value: 2 },
      { label: "按区县", value: 3 }
    ]
  } else if (type == 2) {
    selectOptions.value = [
      //{ label: "按省份", value: 1 },
      { label: "按城市", value: 2 },
      { label: "按区县", value: 3 }
    ]
    if(currentZoomStr == 'district'){
      isShowRangeSearch.value = 1;
      setMapZooms([2,20]);
      resetDraw();
    }
    if(currentZoomStr == "province" && selectType.value == 4){
      map.setZoom(4.85);
      urbanAgglomerationsValue.value = null;
      // selectType.value = 1;
      return;
    }else{
      urbanAgglomerationsValue.value = null;
      // selectType.value = 1;
    }
  }


  getProjectPageList(1);
  if (currentZoomStr == "province") {
    createProvinceMarker();
    getRightPannelInfo(currentZoomStr, currentAreaCodes[1]);
  } else if (currentZoomStr == "city") {
    createCityMarker();
    getRightPannelInfo(currentZoomStr, currentAreaCodes[2]);
  } else if (currentZoomStr == "district") {
    getProjectListFn(currentAreaCodes[3]);
  }
}
const getCurrentPageDataType = () => {
  return currentMapDataType.value;
}
const getSwitchState = (type) => {
  if(type=='project-name')
    return projectNameSwitch.value;
  else if(type='project-point')
    return projectPointSwitch.value;
}
const setSwitchState = (type,val) => {
  if(type=='project-name'){
    projectNameSwitch.value=val;
    switchProjectName(val)
  }
  else if(type='project-point'){
    projectPointSwitch.value=val;

  }
}
const switchProjectName= (val) => {
	if(val==1)
		isNeedClearMarkers.forEach(mk => {
			try{
				mk.dom.querySelector('.project-item-name').style.visibility = 'visible';
			}catch(e){
				
			} 
		})
	else
		isNeedClearMarkers.forEach(mk => {
		    try{
		    	mk.dom.querySelector('.project-item-name').style.visibility = 'hidden';
		    }catch(e){	    	
		    }
		})

  // console.info(val)
  // if(val==1)
  //   isNeedClearMarkers.forEach(mk => {
  //     try{
  //       mk.dom.querySelector('.project-item-name').style.display = 'block';
  //     }catch(e){

  //     }
  //   })
  // else
  //   isNeedClearMarkers.forEach(mk => {
  //     try{
  //       mk.dom.querySelector('.project-item-name').style.display = 'none';
  //     }catch(e){
  //     }
  //   })

}
const hiddenProjectPointState=(val)=>{
  hiddenProjectPoint=val;
  switchProjectName(projectPointSwitch.value)
}
const hiddenProjectNameState=(val)=>{
  hiddenProjectName = val;
  switchProjectName(projectNameSwitch.value)
}
const switchProjectPoint= (val) => {
  if(val==1)
    isNeedClearMarkers.forEach(mk => {
      try{
        mk.dom.querySelector('.area-marker-icon').style.display = 'block';
      }catch(e){}
      try{
        mk.dom.querySelector('.area-marker-info-box').style.display = 'none';
      }catch(e){}
    })
  else
    isNeedClearMarkers.forEach(mk => {
      try{
        mk.dom.querySelector('.area-marker-icon').style.display = 'none';
      }catch(e){}
      try{
        mk.dom.querySelector('.area-marker-info-box').style.display = 'block';
      }catch(e){}
    })
}

const switchProjectRemark= (val) => {
  // if(val==1)
  // 	isNeedClearMarkers.forEach(mk => {
  // 	    mk.dom.querySelector('.area-marker-icon').style.display = 'block';
  // 	})
  // else
  // 	isNeedClearMarkers.forEach(mk => {
  // 	    mk.dom.querySelector('.area-marker-icon').style.display = 'none';
  // 	})
}

const handleCurrentChange = (val) => {
  getProjectPageList(val);
}
const selectTypeHandler = (val) => {
  // clearIsNeedClearMarkers();

  if(val == 4){
    // cityCurrentModel.value = null;
  }else{
    cityListOptions.value = JSON.parse(JSON.stringify(cityList));
    if (val == 1) {
      cityListOptions.value.forEach(province => {
        province.children = [];
      })
    } else if (val == 2) {
      cityListOptions.value.forEach(province => {
        province.children.forEach(city => {
          city.children = [];
        })
      })
    } else if (val == 3) {
      cityListOptions.value.forEach(province => {
        province.children.forEach(city => {
          (city.children ||[]).forEach(area => {

            area.children = [];
          })
        })
      })
    }
    urbanAgglomerationsValue.value = [];
  }

}

const renderHeander = ({ column, $index }) => {
  if ($index == 1) {
    return h('div', {
      style: {
        display: "flex",
        alignItems: "center",
        width: "100%",
        justifyContent: "center"
      }
    }, [
      h('span', {}, column.label),
      h(ElTooltip, {
        effect: "light",
        content: "包含建成面积与在建面积",
        placement: "top"
      }, () => h('div', {
        class: "iconfont icon-runtongyiyaoyihuifu_gantanhao-65 tool-tip-style"
      }))
    ])
  }

}

const showMapItemOption = (item) => {
  // optionList.value.forEach(citem => citem.hidden = true);
  if (item.hidden) {
    item.value = [...item.cacheValue];
    if (item.id == 1) {
      totalAreaInput1.value = totalAreaInputCache1.value;
      totalAreaInput2.value = totalAreaInputCache2.value;
    } else if (item.id == 5) {
      normalRentAreaInput1.value = normalRentAreaInputCache1.value;
      normalRentAreaInput2.value = normalRentAreaInputCache2.value;
    } else if (item.id == 6) {
      vacancyRateInput1.value = vacancyRateInputCache1.value;
      vacancyRateInput2.value = vacancyRateInputCache2.value;
    } else if (item.id == 7) {
      effectiveRentInput1.value = effectiveRentInputCache1.value;
      effectiveRentInput2.value = effectiveRentInputCache2.value;
    }
  }
  item.hidden = !item.hidden;
}

const resetTotalAreaOption = (item) => {
  resetItemOption(item);
  totalAreaInput1.value = '';
  totalAreaInput2.value = ''
}

const resetRentAreaOption = item => {
  resetItemOption(item);
  normalRentAreaInput1.value = '';
  normalRentAreaInput2.value = ''
}

const resetVacancyRateOption = item => {
  resetItemOption(item);
  vacancyRateInput1.value = '';
  vacancyRateInput2.value = ''
}


const resetEffectiveRentOption = item => {
  resetItemOption(item);
  effectiveRentInput1.value = '';
  effectiveRentInput2.value = ''
}
const resetItemOption = (item, checkAll, type) => {
  item.value = [];
  if (checkAll) {
    if (type === 1) {
      checkAll1.value = false;
    } else if (type === 2) {
      checkAll2.value = false;
    }
  }
}

const closeMapItemOption = (item) => {
  item.hidden = true;
}
let additionalParamList = {};
const okMapItemOption = item => {

  item.hidden = true;

  optionList.value.forEach(item => {
    additionalParamList[item.key] = [...item.value];
    item.cacheValue = [...item.value];
    if (item.key == 'totalArea') {
      let val = `${totalAreaInput1.value},${totalAreaInput2.value}`;

      totalAreaInputCache1.value = totalAreaInput1.value;
      totalAreaInputCache2.value = totalAreaInput2.value;
      console.info("totalAreaInput2.value",totalAreaInput2.value);
      if (val != ",") {
        additionalParamList[item.key].push(val)
      }

    } else if (item.key == 'normalRentArea') {
      let val = `${normalRentAreaInput1.value},${normalRentAreaInput2.value}`;
      normalRentAreaInputCache1.value = normalRentAreaInput1.value;
      normalRentAreaInputCache2.value = normalRentAreaInput2.value;
      if (val != ",") {
        additionalParamList[item.key].push(val);
      }
    } else if (item.key == 'vacancyRate') {
      let val = `${vacancyRateInput1.value},${vacancyRateInput2.value}`;
      vacancyRateInputCache1.value = vacancyRateInput1.value;
      vacancyRateInputCache2.value = vacancyRateInput2.value;
      if (val != ",") {
        additionalParamList[item.key].push(val);
      }
    } else if (item.key == 'effectiveRent') {
      let val = `${effectiveRentInput1.value},${effectiveRentInput2.value}`
      effectiveRentInputCache1.value = effectiveRentInput1.value;
      effectiveRentInputCache2.value = effectiveRentInput2.value;
      if (val != ",") {
        additionalParamList[item.key].push(val);
      }
    } else if (item.key == 'maxBuiltTime') {
      let arr = [];
      additionalParamList[item.key].forEach(date => {
        let year = date.getFullYear();
        let month = date.getMonth() + 1 >= 10 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1);
        let day = date.getDate() >= 10 ? date.getDate() : "0" + date.getDate();
        arr.push(year + "-" + month + "-" + day);
      })
      additionalParamList[item.key] = arr;
    }
    additionalParamList[item.key] = additionalParamList[item.key].join(',');
  })

  let code;
  if (currentZoomStr == "province") {
    code = currentAreaCodes[1];
  } else if (currentZoomStr == "city") {
    code = currentAreaCodes[2];
  } else if (currentZoomStr == "district") {
    code = currentAreaCodes[3];
  }
  console.info("additionalParamList")
  console.info(additionalParamList)

  let keys = Object.keys(additionalParamList);
  keys.forEach(key => {
    if (additionalParamList[key].length == 0) {
      delete additionalParamList[key];
    }
  })
  if (currentZoomStr == "province") {
    createProvinceMarker();
    getRightPannelInfo(currentZoomStr, currentAreaCodes[1]);
  }
  if (currentZoomStr == "city") {
    if (Object.keys(additionalParamList).length == 0) {
      createCityMarker();
    } else {
      getProjectListFn(code, { paramList: additionalParamList });
    }
    getRightPannelInfo(currentZoomStr, currentAreaCodes[2]);
  } else if (currentZoomStr == "district") {
    getProjectListFn(code, { paramList: additionalParamList });
  }
}

const clearMapItemOption = () => {
  optionList.value.forEach(citem => {
    citem.value = [];
    citem.cacheValue = [];
  })
  checkAll1.value = false;
  checkAll2.value = false;
  totalAreaInput1.value = "";
  totalAreaInput2.value = "";
  totalAreaInputCache1.value = "";
  totalAreaInputCache2.value = "";
  normalRentAreaInput1.value = "";
  normalRentAreaInput2.value = "";
  normalRentAreaInputCache1.value = "";
  normalRentAreaInputCache2.value = "";
  vacancyRateInput1.value = "";
  vacancyRateInput2.value = "";
  vacancyRateInputCache1.value = "";
  vacancyRateInputCache2.value = "";
  effectiveRentInput1.value = "";
  effectiveRentInput2.value = "";
  effectiveRentInputCache1.value = "";
  effectiveRentInputCache2.value = "";


  let code;
  if (currentZoomStr == "province") {
    code = currentAreaCodes[1];
  } else if (currentZoomStr == "city") {
    code = currentAreaCodes[2];
  } else if (currentZoomStr == "district") {
    code = currentAreaCodes[3];
  }

  if (currentZoomStr == "city") {
    createCityMarker();
  } else if (currentZoomStr == "district") {
    getProjectListFn(code, { paramList: {} });
  }
}

const changeCityName = (name) => {
  cityName.value = name;
}

const getCurrentCityCode = (val) => {
  let keys = Object.keys(val);
  let code = val[keys[keys.length - 1]];
  return code;
}

const getDataTotalFn = async (type, code) => {
  let params = {};
  console.info("code",code)
  if (type == 'province') {
    // if(type == 'group'){
    if(selectType.value == 4){
      params = {
        groupname: urbanAgglomerationsValue.value
      }
    }else{
      params = {
        provCode: code
      }
    }
  } else if (type == 'city') {
    let pks = [110000, 120000, 310000, 500000];
    if (pks.includes(code)) {
      params = {
        provCode: code
      }
    } else {
      params = {
        cityCode: code
      }
    }
  }
  try{
    let { data } = await request({
      url: GetDataTotal,
      method: "post",
      data: {
        quarter,
        isHighBar: currentMapDataType.value,
        ...params,

        paramList: {...additionalParamList}
      }
    })
    if(data==null){
      return [];
    }
    warehouseData.value = data[0] ? data[0] : [];
	console.info("warehouseData",warehouseData)
    return data;
  }catch(e){
  }

}

const getAddtionParamList = () =>{
	return additionalParamList;
}

const getLandtotalFn = async (type, code) => {
  let params = {};
  if (type == 'province') {
    if(selectType.value == 4){
      params = {
        groupname: urbanAgglomerationsValue.value
      }
    }else{
      params = {
        provCode: code
      }
    }
  } else if (type == 'city') {
    let pks = [110000, 120000, 310000, 500000];
    if (pks.includes(code)) {
      params = {
        provCode: code
      }
    } else {
      params = {
        cityCode: code
      }
    }
  }
  let { data } = await request({
    url: Landtotal,
    method: "post",
    data: {
      quarter,
      ...params,
      isHighBar: currentMapDataType.value,
      paramList: {...additionalParamList}
    }
  })

  landData.value = data;

  return data;
}

const getGetDataTopNumberFn = async (type, code) => {
  let params = {};
  if (type == 'province') {
    if(selectType.value == 4){
      params = {
        groupname: urbanAgglomerationsValue.value
      }
    }else{
      params = {
        provCode: code
      }
    }
  } else if (type == 'city') {
    let pks = [110000, 120000, 310000, 500000];
    if (pks.includes(code)) {
      params = {
        provCode: code
      }
    } else {
      params = {
        cityCode: code
      }
    }
  }

  // cityAuthList=cityAuthData.data

  let { data } = await request({
    url: GetDataTopNumber,
    method: "post",
    data: {
      quarter,
      ...params,
      isHighBar: currentMapDataType.value
      // paramList: {...additionalParamList}
    }
  })
  data.forEach(item => {
    item.areaTotal = Math.round(item.areaTotal).toLocaleString();
  })
  tableData.value = data;
  return data;
}

const getProjectPageList = async (pageNum) => {
  if (!projectName.value) return;
  let params = {};

  if (cityCurrentModel.value) {
    let keys = Object.keys(cityCurrentModel.value);
    let cityKey = "";
    if (keys.length == 1) {
      cityKey = "provCode"
    } else if (keys.length == 2) {
      cityKey = "cityCode"
    } else if (keys.length == 3) {
      cityKey = "areaCode"
    }
    params = {};
    params[cityKey] = cityCurrentModel.value[cityCurrentModel.value.length - 1];
  }

  let result = await request({
    url: GetProjectPageList,
    method: "post",
    data: {
      pageSize: PAGESIZE,
      pageNum: pageNum,
      quarter,
      projectName: projectName.value,
      isHighBar: currentMapDataType.value,
      ...params,
      paramList: {}
    }
  })

  list.value = result.rows;
  listPageTotal.value = Number(result.total);
  createMarkers(result.rows);
}


const getRightPannelInfo = async (type, code) => {
  getDataTotalFn(type, code);
  getLandtotalFn(type, code);
  getGetDataTopNumberFn(type, code);
}

// const getDataListFn = async () => {
//     let { data } = await request({
//         url: GetDataList,
//         method: "post",
//         data: {
//             paramList: {
//                 quarter,
//                 provCode: "",
//                 cityCode: "210100",
//                 areaCode: ""
//             },
//             projectName: ""
//         }
//     })

//     console.log(data);
// }

const changeDataType = (type) => {
  dataType.value = type;
}
const searchHandler = () => {
  isSearchModel.value = true;
  cityCurrentModel.value = null;
  getProjectPageList(1);
  returnChinaMap();
}

const projectNameChangeHandler = () => {
  if (projectName.value == "") {
    isSearchModel.value = false;
    removeMarkList();
    list.value = "";
  }
}

const getSearchModel = () => {
  return isSearchModel.value;
}

const listItemMouseEnterHandler = (index) => {
  listItemFocusIndex.value = index;
  hoverCurrentItem(index);
}

const listBoxMouseOut = (e) => {
  cancelHoverCurrentItem();
  listItemFocusIndex.value = null;

}

const listItemShowInfo = (index) => {
  isListItemShowIndex.value = index + 1;
}

const returnList = () => {
  listItemMouseEnterHandler(0)
  listBoxMouseOut();
  isListItemShowIndex.value = 0;
}
const gotoProjectPage = (e) =>{
  let selData = list.value[isListItemShowIndex.value-1];
  const _router = useRouter();
  console.log(_router)
  _router.push({
    path: '/insight/project',
    query: {
      rptNumber: selData.rptNumber
    },
    target: '_blank'
  })

  //window.open('/insight/project?projectName='+selData.projectName+"&rptId="+selData.rptId,'_blank');
}

const getListItemShowIndex = () => {
  return isListItemShowIndex.value;
}

const tirggleShowDataInfo = (flag) => {
  isShowDataInfo.value = flag;
}

const setShowFilterOptions = (flag) => {
  isShowFilterOptions.value = flag;
}


let isHideSearch = ref(true);
const hideSearchBox = () => {
  isHideSearch.value = !isHideSearch.value;
}

const changeCityCurrent = (val) => {
  let keys = Object.keys(val);
  let keysLen = keys.length;
  let codes = [];
  let current = cityList;
  for (let i = 0; i < keysLen; i++) {
    let key = keys[i];
    let currentCity = current.find(item => cityCurrentModel.value[key] == item.code);
	console.info('changeCity2',val)
    if (i == keysLen - 1) {
      current = currentCity;
    } else {
      current = currentCity.children;
    }
    codes.push(val[key]);
  }
  console.info('changeCity4',val)
  let oldAreaCode = currentAreaCodes[keysLen];
  isSearchModel.value = false;
  projectName.value = "";
  removeMarkList();
  list.value = "";
  selectType

  let cityType='city';
  let zoom=8;
  if (keysLen == 1) {
    cityType = "province"
    zoom = 8
  } else if (keysLen == 2) {
    let pks = ["110000", "120000", "310000", "500000"];
    if (pks.includes(val[1])) {
      cityType = "province"
      zoom = 8
    } else {
      cityType = "city"
      zoom = 10
    }
    // cityType = "city"
    // zoom = 10
  } else if (keysLen == 3) {
    cityType = "district"
    zoom = 12.94
  }

  // let currentAreaCode = val[keysLen - 1];
  // console.log(oldAreaCode, currentAreaCode, oldAreaCode == currentAreaCode, '123')
  districtExplorer.emit("featureClick", {}, {
    properties: {
      adcode: Number(current.code),
      center: [Number(current.gpsLon), Number(current.gpsLat)],
      name: current.name
    },
    type: "Feature",
    emitType: "my",
    zoom: zoom,
    val
  })
  // if(oldAreaCode == currentAreaCode){
  //     console.log('click')

  // }else{
  //     districtExplorer.emit("outsideClick", {
  //         originalEvent: {
  //             lnglat: [Number(current.gpsLon), Number(current.gpsLat)]
  //         },
  //         emitType: "my",
  //         zoom: zoom,
  //         val
  //     })
  // }

  // if (currentZoomStr == "country" || currentZoomStr == "district") {
  //     let cityType;
  //     let zoom;
  //     if (keysLen == 1) {
  //         cityType = "country"
  //         zoom = 7
  //     } else if (keysLen == 2) {
  //         cityType = "province"
  //         zoom = 10
  //     } else if (keysLen == 3) {
  //         cityType = "city"
  //         zoom = 12.94
  //     }
  //     console.log(1)
  //     districtExplorer.emit("featureClick", {}, {
  //         properties: {
  //             adcode: Number(current.code),
  //             center: [Number(current.gpsLon), Number(current.gpsLat)],
  //             name: current.name
  //         },
  //         type: "Feature",
  //         emitType: "my",
  //         cityType: cityType,
  //         zoom: zoom
  //     })
  // } else {

  //     let cityType;
  //     let zoom;
  //     console.log(keysLen)
  //     if (keysLen == 1) {
  //         cityType = "province"
  //         zoom = 7
  //     } else if (keysLen == 2) {
  //         let pks = ["110000","120000","310000","500000"];
  //         console.log(val[1],"8888888888888")
  //         if(pks.includes(val[1])){
  //             cityType = "province"
  //             zoom = 7
  //         }else{
  //             cityType = "city"
  //             zoom = 10
  //         }
  //     }else if(keysLen == 3){
  //         cityType = "city"
  //         zoom = 12.94
  //     }

  //     console.log(zoom)

  //     if ((currentZoomStr == "province" || currentZoomStr == "city")) {
  //         console.log(2)
  //         districtExplorer.emit("outsideClick", {
  //             originalEvent: {
  //                 lnglat: [Number(current.gpsLon), Number(current.gpsLat)]
  //             },
  //             emitType: "my",
  //             cityType: cityType,
  //             zoom: zoom
  //         })
  //     }


  // }




}

const changeCityCurrentModel = (routeFeatures, isChange) => {
  if(selectType.value == 4 && !isChange) return;
  let val = [];
  routeFeatures.forEach((item, index) => {
    val.push(item.toString());
  })
  selectTypeHandler(routeFeatures.length);
  selectType.value = routeFeatures.length;
  cityCurrentModel.value = val;

}
const clearCityCurrentModey = () => {
  selectTypeHandler(2);
  selectType.value = 2;
  cityCurrentModel.value = [];
}

const selectAll = (event, item, vals) => {
  if (event) {
    item.value = vals.map(item=>"'"+item+"'");
  } else {
    item.value = []
  }
}

const changeCheckItemHandler = (item, type) => {
  if (type == 1) {
    checkAll1.value = item.value.length == 3;
  } else if (type == 2) {
    checkAll2.value = item.value.length == 3;
  }

}

const changeSelectFilterOptions = [
  { label: "已建成", value: 1 },
  { label: "部分建成", value: 2 },
  { label: "在建", value: 3 }
]

const changeProjectSelectTypeHandler = (val) => {
  projectFilterType.value = val;
  projectFilterAll.value = val.length == 3;
  hiddenMarkerList([...projectFilterType.value]);
}

const changeProjectSelectTypeAllHandler = (val) => {
  changeProjectSelectTypeHandler(val == true ? [1, 2, 3] : []);
}

const reload = () => {
  location.reload();
}

const showCampare = (flag) => {
  isShowCampare.value = flag;
}

let isShowRangeSearch = ref(0);

const setShowRangeSearch = (type) => {
  console.info("setShowRangeSearch",type);
  isShowRangeSearch.value = type;
  if(type == 2){
    setShowFilterOptions(false);

    setMapZooms([11,20])
  }else if(type==1){
	setMapZooms([2,20]);
	resetDraw();
	let isInIsNeedClearMarkers;
	for(let i=0; i<isNeedClearMarkers.length; i++){
	    let m = isNeedClearMarkers[i];
	    let oed = m.getExtData();
		m.setExtData({...oed, isCircle: false})
		try{
			m.dom.querySelector('.project-item-icon').innerHTML = '';   
		}catch(e){
			
		} 
	}  
  }
  else{
    // setShowFilterOptions(true);
    setMapZooms([2,20]);
    resetDraw();
	let isInIsNeedClearMarkers;

	for(let i=0; i<isNeedClearMarkers.length; i++){
	    let m = isNeedClearMarkers[i];
	    let oed = m.getExtData();
		m.setExtData({...oed, isCircle: false})
		try{
			m.dom.querySelector('.project-item-icon').innerHTML = '';   
		}catch(e){
			
		} 
		
	}
  }
}

const getShowRangeSearch = () => {
  return isShowRangeSearch.value;
}

const resetDraw = () => {
  reDrawCircle();
  circleSearchList.value = [];
  isShowCircleSearchList.value = false;
}

let circleSearchList = ref([]);
let isShowCircleSearchList = ref(false);
let isShowCircleList = ref(true);

const triggleShowCircleListFn = () => {
  isShowCircleList.value = !isShowCircleList.value;
}

const getDrawCircleData = async (lng1,lat1, radius, isNeedClearMarkers) => {
  let { data } = await request({
    url: searchProjectList,
    method: "post",
    data: {
      quarter,
      isHighBar: currentMapDataType.value,
      lng1:lng1,
      lat1:lat1,
      kilometre: radius
    }
  })
  console.log(isNeedClearMarkers)

  let localList = localStorage.getItem('campareList');
  localList = localList ? JSON.parse(localList) : [];


  for(let i = 0; i<data.length; i++){
    let item = data[i];

    for(let j=0; j<localList.length; j++){
      let citem = localList[j];
      if(citem.rptId == item.rptId){
        item.isCampareModel = true;
      }
    }
console.info("getDrawCircleData")
    item.isCircle = true;
  }


  circleSearchList.value = data;
  isShowCircleSearchList.value = !!data.length;
  return data;
}

const getCircleSearchList = () => {
  return circleSearchList;
}


let currentMouseoverMarker = null;
const mateMarkerHover = (item) => {
  // let {isCampare} = item.marker.getExtData();
  // if(!isCampare){
  //     item.marker.dom.querySelector('.project-item-icon').className = "project-item-icon project-item-b4"
  // }
  if(currentMouseoverMarker){
    currentMouseoverMarker.dom.onmouseout();
  }
  item.marker.dom.onmouseover();
  currentMouseoverMarker = item.marker;
}

const mateMarkerOut = (e, item) => {
  let isRemoveClass = false;
  let parentNode = e.toElement;
  while(parentNode){
    if(parentNode.className && parentNode.className.indexOf('map-ds-distance-item') >= 0){
      isRemoveClass = true;
    }
    parentNode = parentNode.parentNode;
  }
  if(!isRemoveClass){
    // restoreProjectMarkerIcon(item.marker);
    item.marker.dom.onmouseout();
    currentMouseoverMarker = null;
  }

}

let campareListData = ref((function(){
  let localList = localStorage.getItem("campareList");
  let list = localList ? JSON.parse(localList) : [];
  let reList = [...list, ...new Array(5 - list.length)];
  return reList;
})());
const addCampare = (data) => {
  isShowCampare.value = 2;
  let localList = localStorage.getItem("campareList");
  let list = localList ? JSON.parse(localList) : [];
  let isInclude = list.find(item => item.rptId == data.rptId);

  if(!isInclude){
    list.push(data);
    let reList = [...list, ...new Array(5 - list.length)];
    campareListData.value = reList;
    localStorage.setItem('campareList',JSON.stringify(campareListData.value.filter(item => {
      if(item && item.marker){
        delete item.marker;
      }
      return item
    })));
  }
}

const showCampareInfo = (type) => {
  isShowCampare.value = type;
}

const minusCompare = (data) => {
  let localList = localStorage.getItem("campareList");
  let list = localList ? JSON.parse(localList) : [];
  let index = list.findIndex(item => item.rptId == data.rptId);
  list.splice(index,1);
  let reList = [...list, ...new Array(5 - list.length)];
  campareListData.value = reList;
  localStorage.setItem('campareList',JSON.stringify(campareListData.value.filter(item => item)));
  let c = circleSearchList.value.find(item => item.rptId == data.rptId);
  if(c) c.isCampareModel = false;
  delCompareDOM(data.rptId);
}

const clearCampare = () => {
  campareListData.value = new Array(5);
  localStorage.setItem('campareList', JSON.stringify([]));
  circleSearchList.value.forEach(item => item.isCampareModel = false);
  delCompareDOM('all');
  
}

const campareCheckHandler = (item) => {
  console.log(item.marker.getExtData().isCampare,"0000000000000000000")

  let {isCampare} = item.marker.getExtData();
  if(!isCampare){
    let localList = localStorage.getItem("campareList");
    let list = localList ? JSON.parse(localList) : [];
    if(list.length == 5){
      ElMessage.error('最多添加5个对比项目');
      item.isCampareModel = false;
      return;
    }
  }

  item.marker.dom.querySelector('.project-info-camparebtn').onclick();
}

const getSelectTypeValue = () =>{
  return selectType.value;
}

const provincesChange = () => {
  console.log("provincesChange")
  let currentGroup = urbanAgglomerationsOptions.find(item => item.groupname == urbanAgglomerationsValue.value);
  let name = "";
  console.log("currentGroup",currentGroup)
  if(currentGroup){
    name = currentGroup.groupname;
    // showTopTen.value=false
    let showCount=0
    for (let i=0;i<cityAuthList.length;i++){
      for (let j = 0; j < currentGroup.provinceVoList.length; j++) {
        
        if (currentGroup.provinceVoList[j].code==cityAuthList[i]){
          showCount+=1
        }
      }
    }
    if (showCount==currentGroup.provinceVoList.length){
      showTopTen.value=true
    }
    
  }
  // isSearchModel.value = false;
  drawProvince(name);
}

const getProvinceVoList = () => {
  let currentGroup = urbanAgglomerationsOptions.find(item => item.groupname == urbanAgglomerationsValue.value);
  let provinceVoList = currentGroup.provinceVoList;
  return provinceVoList;
}

const getUrbanAgglomerationsValue = () => {
  return urbanAgglomerationsValue.value;
}

const compareHandler = () => {
  let localList = localStorage.getItem("campareList");
  let list = localList ? JSON.parse(localList) : [];
  if(circleSearchList.value.length > 0){
    circleSearchList.value.forEach(item => {
      for(let i=0; i<list.length; i++){
        let citem = list[i];
        if(citem.rptId == item.rptId){
          citem.distance = item.distance;
          break;
        }
      }
    })
  }else{
    list.forEach(item => {
      item.distance = null;
    })
  }
  localStorage.setItem('campareList',JSON.stringify(list));
}

onMounted(async () => {
  let instance = getCurrentInstance();
  let cityAuthData = await request({
    url: getCityGroupList,
    method: 'post',
    data: {
      groupname: '',
      quarter: ''
    }
  })
  cityAuthList=[]
  cityAuthData.data.forEach(city=>{
    if (city.hasAuth==true){
      city.provinceVoList.forEach(prov=>{
        cityAuthList.push(prov.code)
      })
    }
  })

  await new Promise(resolve => {
    initAmap(resolve, {
      tirggleShowDataInfo,
      getRightPannelInfo,
      getCurrentPageDataType,
      changeCityName,
      setShowFilterOptions,
      getSearchModel,
      changeCityCurrentModel,
      clearCityCurrentModey,
      listItemShowInfo,
      getListItemShowIndex,
      setIsShowProjectFilter,
      setShowRangeSearch,
      getShowRangeSearch,
      getDrawCircleData,
      addCampare,
      showCampareInfo,
      minusCompare,
      getCircleSearchList,
      getSelectTypeValue,
      getProvinceVoList,
      getUrbanAgglomerationsValue,
      getSwitchState,
      setSwitchState,
      hiddenProjectPointState,
      hiddenProjectNameState,
	  getAddtionParamList
    });
  })
  loadingVisible = true;
	// const loading = ElLoading.service({
	// 		lock: true,
	// 		text: '加载中...',
	// 		background: 'rgba(0, 0, 0, 0.7)'
	// 	  });
  let { data } = await request({
    url: getClientHeadData,
    data: {
      filterateaear: false
    }
  })
  
  // loading.close();
  loadingVisible = false;
  cityList = data.provinces;
  
  urbanAgglomerationsOptions = data.groupnamelist;

  selectTypeHandler(selectType.value);
})


onUnmounted(() => {

})




</script>
<template>
  <div class="map-page">

    <div class="map-box" id="container"></div>
    <div class="map-data-search-box">
      <div class="map-data-search">
        <div class="map-ds-type"
             :class="{ 'map-ds-type1': currentMapDataType == 1, 'map-ds-type2': currentMapDataType == 2 }">
          <div class="map-ds-item" :class="{ 'map-ds-current': currentMapDataType == 1 }"
               @click="changeCurrentPageDataType(1)"><b class="iconfont icon-cangku0"></b>高标仓</div>

          <!--   <div class="map-ds-item" :class="{ 'map-ds-current': currentMapDataType == 2 }"
                 @click="changeCurrentPageDataType(2)"><b class="iconfont icon-lengku0"></b>冷库</div> -->

        </div>
        <div class="map-ds-proname">
          <input type="text" placeholder="请输入项目名称" v-model="projectName" @input="projectNameChangeHandler" />
          <span class="iconfont icon-shousuo0" @click="searchHandler"></span>
        </div>
        <div class="map-ds-citys">
          <div class="map-ds-select">
            <el-select v-model="selectType"   @change="selectTypeHandler">
              <el-option v-for="item in selectOptions" :key="item.value" :label="item.label"
                         :value="item.value" />
            </el-select>
          </div>
          <span class="map-dss-line"></span>
          <div class="map-ds-select-res">
<!--            @visible-change="cityCascaderVisChange"  popper-class="cityLoading"-->
            <el-cascader
                placeholder="请选择"
                filterable
                v-model="cityCurrentModel"
                :options="cityListOptions"
                :props="{ label: 'name', value: 'code', expandTrigger: 'hover' }"
                @change="changeCityCurrent"
                v-if="selectType != 4" />


            <el-select
                filterable
                v-model="urbanAgglomerationsValue"
                @change="provincesChange"
                v-else>
              <el-option v-for="opt in urbanAgglomerationsOptions" :label="opt.groupname" :key="opt.value"
                         :value="opt.groupname" ></el-option>
            </el-select>
          </div>
		  
        </div>
      </div>
	 <!-- <div class="loading-overlay"  v-show="loadingVisible">
	     <el-loading :visible="true"></el-loading>
	     <p class="tips_css">正在载入数据，请稍后！</p>
	   </div> -->
      <div class="map-search-result-list" v-if="list.length > 0" v-show="isListItemShowIndex == 0"
           @mouseout="listBoxMouseOut">
        <div class="map-sr-list-box">
          <div v-for="(item, index) in list" :key="item.rptId" class="map-sr-item"
               :class="{ 'map-sr-current': listItemFocusIndex == index }" @click="listItemShowInfo(index)"
               @mouseenter="listItemMouseEnterHandler(index)" @mouseout.stop>
            <span class="map-sr-index">{{ index + 1 }}</span>
            <div class="map-sr-content">
              <span>{{ item.projectName }}</span>
              <p>建成状态：{{ item.buildingState }}</p>
            </div>
          </div>
        </div>
        <!-- <div class="map-sr-pages" v-show="listPageTotal > PAGESIZE">
            <el-pagination v-model:current-page="currentPage" :page-size="PAGESIZE" small="small"
                layout="prev, pager, next" :total="listPageTotal" @current-change="handleCurrentChange"
                :pager-count="8" />
        </div> -->
        <div class="map-sr-pages">
          <el-pagination v-model:current-page="currentPage" :page-size="PAGESIZE" small="small"
                         layout="prev, pager, next" :total="listPageTotal" @current-change="handleCurrentChange"
                         :pager-count="8"/>
        </div>
      </div>
      <div class="area-block-info" v-if="!isShowDataInfo && isListItemShowIndex > 0">
        <div class="area-bi-name">
          <div class="area-bi-name-box">
            <span class="area-bi-name-icon">{{ isListItemShowIndex }}</span>
            <div class="area-bi-name-text" @click="gotoProjectPage($event)">
              <router-link
                  style="text-decoration: none;color: #1D83E6;"
                  :to="useInsightProject(list[isListItemShowIndex - 1].rptNumber)"
                  target="_blank"
              >
                {{ list[isListItemShowIndex - 1].projectName }}
              </router-link>
            </div>
          </div>

          <div class="area-bi-return" @click="returnList">
            <i class="iconfont icon-jiantou-xiangzuo"></i>
            <span>返回</span>
          </div>
        </div>
        <div class="area-bi-info">
          <div class="area-bi-line">
            <div class="area-bi-block">
              <span class="area-bi-title">建成面积：</span>
              <i class="area-bi-total">{{
                  list[isListItemShowIndex - 1].areaTotal ? list[isListItemShowIndex
                  - 1].areaTotal.toLocaleString() : 0
                }}</i>
              <b class="area-bi-unit area-bi-c"> ㎡</b>
            </div>
            <div class="area-bi-block">
              <span class="area-bi-title">空置率：</span>
			  
              <i class="area-bi-total">{{
				  list[isListItemShowIndex - 1].buildingState=='在建'?'-':
                  list[isListItemShowIndex - 1].vacancyRate ?
                      (list[isListItemShowIndex - 1].vacancyRate * 100).toFixed(2) : 0
                }}</i>
              <b class="area-bi-unit"> {{
				  list[isListItemShowIndex - 1].buildingState=='在建'?'':'%'}}</b>
            </div>
          </div>
          <div class="area-bi-line">
            <div class="area-bi-block">
              <span class="area-bi-title">在建面积：</span>
              <i class="area-bi-total">{{warehouseArea(list[isListItemShowIndex - 1].buildingArea)}}</i>
              <b class="area-bi-unit area-bi-c"> ㎡</b>
            </div>
            <div class="area-bi-block">
              <span class="area-bi-title">建筑类型：</span>
              <i class="area-bi-total">{{ list[isListItemShowIndex - 1].rptBuildingTypeNames }}</i>
            </div>
          </div>
          <div class="area-bi-line">
            <div class="area-bi-block area-bi-block-all">
              <span class="area-bi-title">预估有效租金：</span>
              <i class="area-bi-total">{{
				  list[isListItemShowIndex - 1].buildingState=='在建'?'-':
                  list[isListItemShowIndex - 1].effectiveRent ?
                      list[isListItemShowIndex -
                      1].effectiveRent.toFixed(2) : "-"
                }}</i>
              <b class="area-bi-unit area-bi-c"> {{
				  list[isListItemShowIndex - 1].buildingState=='在建'?'':'元/㎡·月'}}</b>
            </div>
          </div>
          <div class="area-bi-line">
            <div class="area-bi-block area-bi-block-all">
              <span class="area-bi-title">建成状态：</span>
              <i class="area-bi-total">{{ list[isListItemShowIndex - 1].buildingState }}</i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class='right-panel-box'>
      <div class="map-info-box" v-show="isShowDataInfo">
        <div class="map-info-summary">
          <div class="map-info-title">
            <b>{{ cityName }}仓储数据概览</b>
            <a href="javascript:;" @click="triggleShowInfo()">{{ isShowInfo ? '收起' : '展开' }}</a>
          </div>
          <div class="map-info-importmsg" v-show="isShowInfo">
            <div class="map-ii-tags">
              <div class="map-ii-tag" :class="{ 'map-ii-tag-cur': dataType == 1 }" @click="changeDataType(1)">
                <span>仓库数据</span>
                <div class="map-ii-current-line"></div>
              </div>
              <div class="map-ii-tag" :class="{ 'map-ii-tag-cur': dataType == 2 }" @click="changeDataType(2)">
                <span>土地数据</span>
                <div class="map-ii-current-line"></div>
              </div>
              <div class="map-ii-tag" :class="{ 'map-ii-tag-cur': dataType == 3 }" @click="changeDataType(3)">
                <span>TOP10开发商</span>
                <div class="map-ii-current-line"></div>
              </div>
            </div>
            <div class="map-ii-data" v-show="dataType == 1">
              <div class="map-iid-item">
								<span>现有存量<el-tooltip effect="light" content="建成面积（包含本季度增量）" placement="top"><s
                    class="iconfont icon-runtongyiyaoyihuifu_gantanhao-65 tool-tip-style"></s></el-tooltip></span>
                <div class="map-iid-text">
                  <b>{{ warehouseData.areaTotal ? warehouseData.areaTotal.toLocaleString() : 0 }}</b>
                  <i>㎡</i>
                </div>
              </div>
              <div class="map-iid-item">
								<span>本季度增量<el-tooltip effect="light" content="本季度建成面积" placement="top"><s
                    class="iconfont icon-runtongyiyaoyihuifu_gantanhao-65 tool-tip-style"></s></el-tooltip></span>
                <div class="map-iid-text">
                  <b>{{ warehouseData.currentSeasonAdd ? warehouseData.currentSeasonAdd.toLocaleString() : 0 }}</b>
                  <i>㎡</i>
                </div>
              </div>
              <div class="map-iid-item">
                <span>空置率</span>
                <div class="map-iid-text">
                  <b>{{!warehouseData.areaTotal||warehouseData.areaTotal==0?'-':
                      (warehouseData.vacancyRate ?
                          (Number(warehouseData.vacancyRate) * 100).toFixed(2) : 0)
                    }}</b>
                  <i>{{!warehouseData.areaTotal||warehouseData.areaTotal==0?'':'%'}}</i>
                </div>
              </div>
              <div class="map-iid-item">
								<span>预估有效租金<el-tooltip effect="light" content="折算免租期、装修期后的租金" placement="top"><s
                    class="iconfont icon-runtongyiyaoyihuifu_gantanhao-65 tool-tip-style"></s></el-tooltip></span>
                <div class="map-iid-text">
                  <b>{{
					  !warehouseData.areaTotal||warehouseData.areaTotal==0?'-':
					      (warehouseData.estimatedEffective ? warehouseData.estimatedEffective.toFixed(2) :
                          "0.00")
                      
                    }}</b>
                  <i>{{!warehouseData.areaTotal||warehouseData.areaTotal==0?'':'元/㎡·月'}}</i>
                </div>
              </div>
              <!-- <div class="map-iid-item">
                <span>平均租金<s class="iconfont icon-runtongyiyaoyihuifu_gantanhao-65"></s></span>
                <div class="map-iid-text">
                  <b>25.88</b>
                  <i>元/㎡·月</i>
                </div>
              </div> -->
            </div>
            <div class="map-ws-info" v-show="dataType == 2">
              <div class="map-ii-data" style="margin-top: 0;">
                <div class="map-iid-item" v-if="landData.transferArea">
                  <span>出让面积</span>
                  <div class="map-iid-text">
                    <b>{{ landData.transferArea.toFixed(2) }}</b>
                    <i>亩</i>
                  </div>
                </div>
                <div class="map-iid-item" v-if="landData.numLandParcelsTransferred">
                  <span>出让宗地数</span>
                  <div class="map-iid-text">
                    <b>{{ landData.numLandParcelsTransferred }}</b>
                  </div>
                </div>
                <div class="map-iid-item" v-if="landData.averageTransactionPrice">
                  <span>成交均价</span>
                  <div class="map-iid-text">
                    <b>{{ landData.averageTransactionPrice.toFixed(2) }}</b>
                    <i>万元/亩</i>
                  </div>
                </div>
                <div v-else style="min-height: 124px;line-height:124px;text-align: center;color: #D6D6D6; width: 100%;">暂无数据</div>
              </div>
            </div>
            <div class="map-ws-table rs-el-table" v-show="dataType == 3">
                <el-table :data="tableData" header-row-class-name="map-ws-table-header" style="font-size:13px">
                  <el-table-column label="开发商" align="center">
                    <template #default="scope">
                      <div class="map-ws-table-index" :title="scope.row.projectDeveloper"
                           :class="{ 'map-ws-table-top': scope.$index < 3 }">
                        <b>{{ scope.$index + 1 }}</b>
                        <span>{{ scope.row.projectDeveloper }}</span>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column style="font-size: 12px;" prop="areaTotal" label="项目总量（㎡）" align="left"
                                   :render-header="renderHeander"></el-table-column>
                  <el-table-column style="font-size: 12px;" prop="areaTotalALLRate" label="市场份额" align="left"></el-table-column>
                </el-table>
            </div>
          </div>
        </div>
      </div>
      <div class="switch-right-panel">
        <div class='project-switch' v-show='!hiddenProjectName'>
          项目名称&nbsp;
          <el-switch
              v-model="projectNameSwitch"
              :active-value="1"
              :inactive-value="0"
              active-text="开"
              @change='switchProjectName(projectNameSwitch)'
              inactive-text="关"/>
        </div>
        <div class='project-switch' v-show='!hiddenProjectPoint'>
          项目点位&nbsp;
          <el-switch
              v-model="projectPointSwitch"
              :active-value="1"
              :inactive-value="0"
              active-text="开"
              @change='switchProjectPoint(projectPointSwitch)'
              inactive-text="关"/>
        </div>
        <div class='project-switch' v-show='!hiddenProjectRemark'>
          显示收藏&nbsp;
          <el-switch
              v-model="projectRemarkSwitch"
              :active-value="1"
              :inactive-value="0"
              active-text="开"
              @change='switchProjectRemark(projectRemarkSwitch)'
              inactive-text="关"/>
        </div>
      </div>
    </div>
   
    <div class="map-district-pro-filter" v-show="isShowProjectFilter">
      <el-checkbox v-model="projectFilterAll" @change="changeProjectSelectTypeAllHandler"
                   class="map-filter-cls-all">全选
      </el-checkbox>
      <el-checkbox-group v-model="projectFilterType" @change="changeProjectSelectTypeHandler">
        <el-checkbox v-for="(item, index) in changeSelectFilterOptions" :label="item.value" :key="item.value"
                     :class="`map-filter-cls-${index}`">{{ item.label }}
        </el-checkbox>
      </el-checkbox-group>
    </div>
    <div class="map-ds-filter-box" :class="{ 'hide-filter-box': !isHideSearch }" v-show="isShowFilterOptions">
      <div class="map-dsf-header">
        <span>筛选条件</span>
        <div class="map-dsf-hbtns">
          <a href="javascript:;" class="delbtn" @click="clearMapItemOption"></a>
          <a href="javascript:;" class="hidebtn" @click="hideSearchBox"></a>
        </div>
      </div>
      <div class="map-dsf-list" v-show="isHideSearch">
        <div class="map-dsf-item" v-for="item in optionList" :key="item.id">
          <div class="map-dsf-item-header" @click="showMapItemOption(item)">
            <span>{{ item.name }}</span>
            <i :class="{ 'minusicon': !item.hidden }"></i>
          </div>

          <template v-if="item.id == 1">
            <div class="map-dsf-item-sr"
                 v-show="item.hidden && (item.cacheValue.length > 0 || (totalAreaInputCache1 != '' || totalAreaInputCache2 != ''))">
                            <span v-for="c in item.cacheValue" :key="c">
                                <template v-if="c.split('<')[0] == ''">{{ c.split('<')[1] + '以下' }}</template>
                                <template v-else-if="c.split('>')[1] == ''">{{ c.split('>')[0] + '以上' }}</template>
                                <template v-else>{{ c.split('-')[0] + '-' + c.split('-')[1] }}</template>
                            </span>
              <span v-if="totalAreaInputCache1 != '' || totalAreaInputCache2 != ''">
                                <template v-if="totalAreaInputCache1 != '' && totalAreaInputCache2 == ''">{{
                                    '自定义：' +
                                    totalAreaInputCache1 +
                                    '以上'
                                  }}</template>
                                <template v-else-if="totalAreaInputCache1 == '' && totalAreaInputCache2 != ''">{{
                                    '自定义：' +
                                    totalAreaInputCache2
                                    + '以下'
                                  }}</template>
                                <template v-else>{{
                                    '自定义：' + totalAreaInputCache1 + '-' + totalAreaInputCache2
                                  }}</template>
                            </span>
            </div>
          </template>
          <template v-else-if="item.id == 2">
            <div class="map-dsf-item-sr" v-show="item.hidden && item.cacheValue.length > 0">
              <template v-if="item.cacheValue.length == 3">
                <span>全选</span>
              </template>
              <template v-else>
                                <span v-for="c in item.cacheValue" :key="c">
                                    {{ c }}
                                </span>
              </template>
            </div>
          </template>
          <template v-else-if="item.id == 3">
            <div class="map-dsf-item-sr" v-show="item.hidden && item.cacheValue.length > 0">
              <template v-if="item.cacheValue.length == 3">
                <span>全选</span>
              </template>
              <template v-else>
                                <span v-for="c in item.cacheValue" :key="c">
                                    {{ c }}
                                </span>
              </template>
            </div>
          </template>
          <template v-else-if="item.id == 4">
            <div class="map-dsf-item-sr" v-show="item.hidden && item.cacheValue.length > 0">
                            <span class="map-dsf-sr-all" v-if="item.cacheValue.length > 0">{{
                                item.cacheValue[0].toJSON().split("T")[0] + ' 至 ' +
                                item.cacheValue[1].toJSON().split("T")[0]
                              }}</span>
            </div>
          </template>
          <template v-else-if="item.id == 5">
            <div class="map-dsf-item-sr"
                 v-show="item.hidden && (item.cacheValue.length > 0 || (normalRentAreaInputCache1 != '' || normalRentAreaInputCache2 != ''))">
                            <span v-for="c in item.cacheValue" :key="c">
                                <template v-if="c.split('<')[0] == ''">{{ c.split('<')[1] + '以下' }}</template>
                                <template v-else-if="c.split('>')[1] == ''">{{ c.split('>')[0] + '以上' }}</template>
                                <template v-else>{{ c.split('-')[0] + '-' + c.split('-')[1] }}</template>
                            </span>
              <span v-if="normalRentAreaInputCache1 != '' || normalRentAreaInputCache2 != ''">
                                <template v-if="normalRentAreaInputCache1 != '' && normalRentAreaInputCache2 == ''">{{
                                    '自定义：' +
                                    normalRentAreaInputCache1 +
                                    '以上'
                                  }}</template>
                                <template
                                    v-else-if="normalRentAreaInputCache1 == '' && normalRentAreaInputCache2 != ''">{{
                                    '自定义：' +
                                    normalRentAreaInputCache2
                                    + '以下'
                                  }}</template>
                                <template v-else>{{
                                    '自定义：' + normalRentAreaInputCache1 + '-' + normalRentAreaInputCache2
                                  }}</template>
                            </span>
            </div>
          </template>
          <template v-else-if="item.id == 6">
            <div class="map-dsf-item-sr"
                 v-show="item.hidden && (item.cacheValue.length > 0 || (vacancyRateInputCache1 != '' || vacancyRateInputCache2 != ''))">
                            <span v-for="c in item.cacheValue" :key="c">
                                <template v-if="c.split('<')[0] == ''">{{ c.split('<')[1] + '以下' }}</template>
                                <template v-else-if="c.split('>')[1] == ''">{{ c.split('>')[0] + '以上' }}</template>
                                <template v-else>{{ c.split('-')[0] + '-' + c.split('-')[1] }}</template>
                            </span>
              <span v-if="vacancyRateInputCache1 != '' || vacancyRateInputCache2 != ''">
                                <template v-if="vacancyRateInputCache1 != '' && vacancyRateInputCache2 == ''">{{
                                    '自定义：' +
                                    vacancyRateInputCache1 +
                                    '%以上'
                                  }}</template>
                                <template v-else-if="vacancyRateInputCache1 == '' && vacancyRateInputCache2 != ''">{{
                                    '自定义：'
                                    +
                                    vacancyRateInputCache2
                                    + '%以下'
                                  }}</template>
                                <template v-else>{{
                                    '自定义：' + vacancyRateInputCache1 + '%-' + vacancyRateInputCache2 + '%'
                                  }}</template>
                            </span>
            </div>
          </template>
          <template v-else-if="item.id == 7">
            <div class="map-dsf-item-sr"
                 v-show="item.hidden && (item.cacheValue.length > 0 || (effectiveRentInputCache1 != '' || effectiveRentInputCache2 != ''))">
                            <span v-for="c in item.cacheValue" :key="c">
                                <template v-if="c.split('<')[0] == ''">{{ c.split('<')[1] + '以下' }}</template>
                                <template v-else-if="c.split('>')[1] == ''">{{ c.split('>')[0] + '以上' }}</template>
                                <template v-else>{{ c.split('-')[0] + '-' + c.split('-')[1] }}</template>
                            </span>
              <span v-if="effectiveRentInputCache1 != '' || effectiveRentInputCache2 != ''">
                                <template v-if="effectiveRentInputCache1 != '' && effectiveRentInputCache2 == ''">{{
                                    '自定义：'
                                    +
                                    effectiveRentInputCache1 +
                                    '以上'
                                  }}</template>
                                <template v-else-if="effectiveRentInputCache1 == '' && effectiveRentInputCache2 != ''">{{
                                    '自定义：' +
                                    effectiveRentInputCache2
                                    + '以下'
                                  }}</template>
                                <template v-else>{{
                                    '自定义：' + effectiveRentInputCache1 + '-' + effectiveRentInputCache2
                                  }}</template>
                            </span>
            </div>
          </template>

          <div class="map-type-search" v-show="!item.hidden" v-if="item.id == 1">
            <div class="map-ts-checkbox">
              <el-checkbox-group v-model="item.value" class="map-ts-check-list">
                <el-checkbox label="<5000">5000以下</el-checkbox>
                <el-checkbox label="5000-10000">5000-10000</el-checkbox>
                <el-checkbox label="10000-20000">10000-20000</el-checkbox>
                <el-checkbox label="20000-50000">20000-50000</el-checkbox>
                <el-checkbox label="50000-100000">50000-100000</el-checkbox>
                <el-checkbox label="100000-200000">100000-200000</el-checkbox>
                <el-checkbox label="200000>">2000000</el-checkbox>
              </el-checkbox-group>
              <div class="map-ts-custom">
                <p>自定义</p>
                <div class="map-ts-input-form">
                  <input type="number" v-model="totalAreaInput1"/>
                  <span>-</span>
                  <input type="number" v-model="totalAreaInput2"/>
                </div>
              </div>
              <div class="map-ts-btns">
                <a href="javascript:;" @click.stop="resetTotalAreaOption(item)">重置</a>
                <a href="javascript:;" class="map-ts-btn-ok" @click.stop="okMapItemOption(item)">确定</a>
              </div>
            </div>
          </div>
          <div class="map-type-search" v-show="!item.hidden" v-else-if="item.id == 2">
            <div class="map-ts-checkbox">
              <el-checkbox label="全选" v-model="checkAll1"
                           @change="e => selectAll(e, item, ['平库', '楼库', '坡道库'])"></el-checkbox>
              <el-checkbox-group v-model="item.value" class="map-ts-check-list" style="margin-top: 0;"
                                 @change="changeCheckItemHandler(item, 1)">
                <el-checkbox label="'平库'">平库</el-checkbox>
                <el-checkbox label="'楼库'">楼库</el-checkbox>
                <el-checkbox label="'坡道库'">坡道库</el-checkbox>
              </el-checkbox-group>
              <div class="map-ts-btns">
                <a href="javascript:;" @click.stop="resetItemOption(item, true, 1)">重置</a>
                <a href="javascript:;" class="map-ts-btn-ok" @click.stop="okMapItemOption(item)">确定</a>
              </div>
            </div>
          </div>
          <div class="map-type-search" v-show="!item.hidden" v-else-if="item.id == 3">
            <div class="map-ts-checkbox">
              <el-checkbox label="全选" v-model="checkAll2"
                           @change="e => selectAll(e, item, ['单面', '双面', '三面'])"></el-checkbox>
              <el-checkbox-group v-model="item.value" class="map-ts-check-list" style="margin-top: 0;"
                                 @change="changeCheckItemHandler(item, 2)">
                <el-checkbox label="'单面'">单面</el-checkbox>
                <el-checkbox label="'双面'">双面</el-checkbox>
                <el-checkbox label="'三面'">三面</el-checkbox>
              </el-checkbox-group>
              <div class="map-ts-btns">
                <a href="javascript:;" @click.stop="resetItemOption(item, true, 2)">重置</a>
                <a href="javascript:;" class="map-ts-btn-ok" @click.stop="okMapItemOption(item)">确定</a>
              </div>
            </div>
          </div>
          <div class="map-type-search" v-show="!item.hidden" v-else-if="item.id == 4">
            <div class="map-ts-checkbox">
              <div class="map-ts-time-range">
                <el-date-picker v-model="item.value" type="monthrange" start-placeholder="开始年月"
                                end-placeholder="结束年月" unlink-panels/>
              </div>

              <div class="map-ts-btns">
                <a href="javascript:;" @click.stop="resetItemOption(item)">重置</a>
                <a href="javascript:;" class="map-ts-btn-ok" @click.stop="okMapItemOption(item)">确定</a>
              </div>
            </div>
          </div>
          <div class="map-type-search" v-show="!item.hidden" v-else-if="item.id == 5">
            <div class="map-ts-checkbox">
              <el-checkbox-group v-model="item.value" class="map-ts-check-list">
                <el-checkbox label="<5000">5000以下</el-checkbox>
                <el-checkbox label="5000-20000">5000-20000</el-checkbox>
                <el-checkbox label="20000-50000">20000-50000</el-checkbox>
                <el-checkbox label="50000-100000">50000-100000</el-checkbox>
                <el-checkbox label="100000>">100000以上</el-checkbox>
              </el-checkbox-group>
              <div class="map-ts-custom">
                <p>自定义</p>
                <div class="map-ts-input-form">
                  <input type="number" v-model="normalRentAreaInput1"/>
                  <span>-</span>
                  <input type="number" v-model="normalRentAreaInput2"/>
                </div>
              </div>
              <div class="map-ts-btns">
                <a href="javascript:;" @click.stop="resetRentAreaOption(item)">重置</a>
                <a href="javascript:;" class="map-ts-btn-ok" @click.stop="okMapItemOption(item)">确定</a>
              </div>
            </div>
          </div>
          <div class="map-type-search" v-show="!item.hidden" v-else-if="item.id == 6">
            <div class="map-ts-checkbox">
              <el-checkbox-group v-model="item.value" class="map-ts-check-list">
                <el-checkbox label="<10">10%以下</el-checkbox>
                <el-checkbox label="10-20">10%-20%</el-checkbox>
                <el-checkbox label="20-40">20%-40%</el-checkbox>
                <el-checkbox label="40-50">40%-50%</el-checkbox>
                <el-checkbox label="50>">50%以上</el-checkbox>
              </el-checkbox-group>
              <div class="map-ts-custom">
                <p>自定义%</p>
                <div class="map-ts-input-form">
                  <input type="number" v-model="vacancyRateInput1"/>
                  <span>-</span>
                  <input type="number" v-model="vacancyRateInput2"/>
                </div>
              </div>
              <div class="map-ts-btns">
                <a href="javascript:;" @click.stop="resetVacancyRateOption(item)">重置</a>
                <a href="javascript:;" class="map-ts-btn-ok" @click.stop="okMapItemOption(item)">确定</a>
              </div>
            </div>
          </div>
          <div class="map-type-search" v-show="!item.hidden" v-else-if="item.id == 7">
            <div class="map-ts-checkbox">
              <el-checkbox-group v-model="item.value" class="map-ts-check-list">
                <el-checkbox label="<15">15以下</el-checkbox>
                <el-checkbox label="15-30">15-30</el-checkbox>
                <el-checkbox label="30-40">30-40</el-checkbox>
                <el-checkbox label="40-50">40-50</el-checkbox>
                <el-checkbox label="50>">50以上</el-checkbox>
              </el-checkbox-group>
              <div class="map-ts-custom">
                <p>自定义</p>
                <div class="map-ts-input-form">
                  <input type="text" v-model="effectiveRentInput1"/>
                  <span>-</span>
                  <input type="text" v-model="effectiveRentInput2"/>
                </div>
              </div>
              <div class="map-ts-btns">
                <a href="javascript:;" @click.stop="resetEffectiveRentOption(item)">重置</a>
                <a href="javascript:;" class="map-ts-btn-ok" @click.stop="okMapItemOption(item)">确定</a>
              </div>
            </div>
          </div>
        </div>

      </div>


      <!-- <i class="iconfont icon-qingchu0 map-dsf-clear" @click="clearMapItemOption">清除</i> -->
    </div>
    <div class="map-campare-box" v-show="currentMapDataType == 1 && isShowCampare == 2">
      <div class="map-campare-left-empty"></div>
      <div class="map-campare-content">
        <div class="map-campare-info">
          <span class="map-campare-hide-btn" @click="showCampare(1)">隐藏</span>
          <div class="map-campare-im">
            <div class="map-campare-list">
              <div class="map-campare-item" v-for="(item,index) in campareListData"
                   :key="item ? item.rptId : Math.random()">
                <template v-if="!!item">
                  <span class="map-campare-name">{{ item.projectName }}</span>
                  <s class="iconfont icon-guanbi0" @click="minusCompare(item)"></s>
                </template>
                <template v-else>
                  <div class="map-campare-add">
                    <b class="map-campare-add-num">{{ index + 1 }}</b>
                    <span class="map-campare-goon">继续添加</span>
                  </div>
                </template>
              </div>
            </div>
            <div class="map-campare-btns">
              <a target="_blank" href="/comparison" class="map-campare-btn" @click="compareHandler"
                 v-if="campareListData.filter(item => item).length > 1">对比</a>
              <a href="javascript:;" class="map-clear-btn" @click="clearCampare()">清空</a>
            </div>
            <div class="map-campare-list-mask"></div>
          </div>
          <!-- <div class="map-campare-list">asdfasdf</div>
          <div class="map-campare-btns">asfas</div> -->
        </div>
      </div>
      <div class="map-campare-right-empty"></div>
    </div>
    <div class="show-campare-btn" @click="showCampare(2)" v-show="isShowCampare == 1">
      <span></span>
      显示对比栏
    </div>
    <div class="map-reload" @click="reload">
      <span></span>
      重置地图
    </div>
    <div class="map-draw-circle" v-show="currentMapDataType == 1 && isShowRangeSearch > 0">
      <a href="javascript:;" class="map-draw-sbtn" @click="setShowRangeSearch(2)" v-show="isShowRangeSearch==1">
        <span>周边搜索</span>
        <s></s>
      </a>
      <div class="map-draw-btns" v-show="isShowRangeSearch==2">
        <a href="javascript:;" class="map-draw-cbtn" @click="setShowRangeSearch(1)">退出</a>
        <span></span>
        <a href="javascript:;" class="map-draw-rbtn" @click="resetDraw()">重绘</a>
        <s></s>
      </div>
    </div>

    <div class="map-ds-distance-box" v-show="currentMapDataType == 1 && isShowCircleSearchList">
      <div class="map-dsf-header">
        <span>周边搜索结果</span>
        <div class="map-dsf-hbtns">
          <a href="javascript:;" class="hidebtn" @click="triggleShowCircleListFn"></a>
        </div>
      </div>
      <div class="map-ds-distance-list" v-show="isShowCircleList">
        <div class="map-ds-distance-item" v-for="(item,index) in circleSearchList" :key="item.rptId"
             @mouseenter="mateMarkerHover(item)" @mouseout="e => mateMarkerOut(e,item)">
          <div class="map-ds-distance-cn">
            <s class="map-ds-distance-index"
               :class="{'map-ds-distance-c': !item.isCampareModel && item.isCircle, 'map-ds-distance-b': item.isCampareModel}">{{
                index + 1
              }}</s>
            <div class="map-ds-distance-info">
              <b>{{ item.projectName }}</b>
              <span>直线距离<i>{{ item.distance }}</i>米</span>
            </div>
          </div>
          <span class="map-ds-distance-campare">
                        <el-checkbox label="对比" v-model="item.isCampareModel"
                                     @change="campareCheckHandler(item)"></el-checkbox>
                    </span>
        </div>
        <div style="height:10px"></div>
      </div>
    </div>
    <!-- <div class="search-frame">
      <el-checkbox label="项目" v-model="item.isCampareModel" @change="campareCheckHandler(item)"></el-checkbox>
    </div> -->
  </div>
</template>
<style lang="less">
@import url('//at.alicdn.com/t/c/font_4256935_6jj4fmzf454.css');
@import url('./map.css');
</style>